import { useLocaleState, useTranslate } from "ra-core";
import { formatArgs } from "./format";
import type { I18nArgs } from "./types";

/** Translates a content key with its rule-derived arguments. */
export function useContentText() {
  const t = useTranslate();
  const [locale = "fr"] = useLocaleState();
  return (key: string, args?: I18nArgs) =>
    t(
      key,
      formatArgs(args, locale, (k) => t(k)),
    );
}
